import Carousel from '../../Components/Homepage/Carousel'
function Home() {
  return ( <Carousel /> )
}
export default Home